import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import DropZone from 'components/Shared/DropZone';
import PieceGestionSearch from 'components/Shared/PieceGestionSearch';
import LigneGestionQualification from 'components/Shared/LigneGestionQualification';
import DepotGestionSelect from 'components/Shared/DepotGestionSelect';


import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';
import { AnomalieType } from 'constants.js';
import { sansDepotMagasin } from 'utils/depotHelper';


const styles = theme => ({
    flexContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },
    formControl: {
        margin: 0
    },
    group: {
        margin: theme.spacing(1, 0)
    },
    heightLabel: {
        height: '30px'
    }
});

const traitementRetourLabel = "Choix traitement";
const traitementsRetour = [
    'Retourner la marchandise au Monné sur ce numéro de dossier. Ne pas faire d\'avoir client.',
    // On supprime ce choix. Attention dans le cas où il serait remplacer à vérifier le comportement à la création ...
    /* 'Faire une correction de stock sur le magasin des quantités reprises. Ne pas faire d\'avoir client.', */
];

class ClientPasRetirerMarchandiseStep extends React.Component {
    state = {
        expandedPanel: 'panelPiece'
    };

    componentDidMount() {
        // On détermine si on doit rendre accessible le bouton pour passer à l'étape suivante ou le bouton de création.
        const { reclamation, onNextStepValid } = this.props;

        // On vérifie que la réclamation possède un enregistrement pour chaque détail.
        let nextStepValid = false;
        if (reclamation !== null && reclamation.qualificationDetails.length > 0) {

            if (reclamation.numeroPiece.length > 0 &&
                reclamation.lignes.length > 0)
            {
                nextStepValid = true;
            }
        }

        onNextStepValid(nextStepValid);
    }

    getTraitementRetour() {
        const { reclamation } = this.props;

        let traitementRetour = '';

        const detailTraitementRetour = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.TraitementRetour);
        if (detailTraitementRetour !== undefined) {
            traitementRetour = detailTraitementRetour.valeurInteger.toString();
        }

        return traitementRetour;
    }


    getDepot() {
        const { reclamation } = this.props;

        let depot = '';

        const detailDepot = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.Depot);
        if (detailDepot !== undefined) {
            depot = detailDepot.valeurString;
        }

        return depot;
    }


    checkErrors(traitementRetour, depot) {
        const { reclamation } = this.props;

        let errors = [];

        if (traitementRetour === '') {
            errors.push({ key: ReclamationQualificationDetailCodes.TraitementRetour, errorMsg: traitementRetourLabel });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.TraitementRetour, errorMsg: null });
        }

        if (reclamation.numeroPiece.length === 0) {
            errors.push({ key: ReclamationQualificationDetailCodes.Piece, errorMsg: 'Veuillez sélectionner une pièce.' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.Piece, errorMsg: null });
        }

        if (reclamation.lignes.length === 0) {
            errors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: 'Saisie obligatoire sur au moins une ligne.' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.NbLignes, errorMsg: null });
        }


        if (traitementRetour === '0') {
            if (depot === '') {
                errors.push({ key: ReclamationQualificationDetailCodes.Depot, errorMsg: 'Veuillez choisir un magasin' });
            }
            else {
                errors.push({ key: ReclamationQualificationDetailCodes.Depot, errorMsg: null });
            }
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.Depot, errorMsg: null });
        }


        return errors;
    }

    handleChangePanel = panel => (event, expandedPanel) => {
        this.setState({
            expandedPanel: expandedPanel ? panel : false
        });
    }

    handleChange = (event) => {
        const { onChange } = this.props;

        const errors = this.checkErrors(this.getTraitementRetour(), this.getDepot());

        onChange(event, errors);
    }

    handleSelectPiece = (value) => {
        const { onSelectPiece } = this.props;

        // On ouvre le panel avec les détailsdes lignes
        this.setState({
            expandedPanel: 'panelLignes'
        });

        const errors = this.checkErrors(this.getTraitementRetour(), this.getDepot());

        onSelectPiece(value, errors);
    }

    handleSelectAllLignes = () => {
        const { onSelectAllLignes } = this.props;

        const errors = this.checkErrors(this.getTraitementRetour(), this.getDepot());

        onSelectAllLignes({ errors, typeAnomalie: AnomalieType.ClientPasRetirerMarchandise, commentaire: "" });

    }

    handleQualificationDetailsTraitementRetourChange = (event) => {
        const { onDetailChange, reclamation } = this.props;

        const qualificationDetails = [{
            position: 0,
            code: ReclamationQualificationDetailCodes.TraitementRetour,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: traitementRetourLabel,
            valeurString: traitementsRetour[event.target.value],
            valeurInteger: parseInt(event.target.value, 10)
        }];

        let detailsToDelete = [];

        // On reset le magasin à celui de l'utilisateur
        if (event.target.value === '0') {

            let codeDepot = reclamation.magasin ? reclamation.magasin.codeDepot : '';
            if (codeDepot === '')
            {
                let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));

                if (sansDepotMagasin(utilisateur)) {
                    if (utilisateur.depots && utilisateur.depots.length === 1) {
                        codeDepot = utilisateur.depots[0].code;
                    }
                }
                else {
                    codeDepot = utilisateur.depot.code;
                }
            }

            if (codeDepot !== '')
            {
                qualificationDetails.push(
                    {
                        position: 1,
                        code: ReclamationQualificationDetailCodes.Depot,
                        type: ReclamationQualificationDetailType.CodeDepot,
                        libelle: "Magasin",
                        valeurString: codeDepot
                    });
            }


            const errors = this.checkErrors(event.target.value, codeDepot);

            onDetailChange(qualificationDetails, errors, detailsToDelete);
        }
        else {
            detailsToDelete.push(ReclamationQualificationDetailCodes.CodeDepot);


            const errors = this.checkErrors(event.target.value, '');

            onDetailChange(qualificationDetails, errors, detailsToDelete);
        }


    }

    handleAddLigne = (ligne) => {
        const { onAddLigne } = this.props;

        const errors = this.checkErrors(this.getTraitementRetour(), this.getDepot());

        onAddLigne(ligne, errors);
    }

    handleRemoveLigne = (numeroLigne) => {
        const { onRemoveLigne } = this.props;

        const errors = this.checkErrors(this.getTraitementRetour(), this.getDepot());

        onRemoveLigne(numeroLigne, errors);
    }



    handleQualificationDetailsCodeDepot = (event, codeDepot) => {
        const { onDetailChange } = this.props;

        console.log('handleQualificationDetailsCodeDepot', codeDepot);

        const qualificationDetail = {
            position: 1,
            code: ReclamationQualificationDetailCodes.Depot,
            type: ReclamationQualificationDetailType.CodeDepot,
            libelle: "Magasin",
            valeurString: codeDepot

        };

        const errors = this.checkErrors(this.getTraitementRetour(), codeDepot);

        onDetailChange(qualificationDetail, errors, null);
    }




    renderDetailsQualifications() {
        const { classes, reclamation } = this.props;

        const detailTraitementRetourValue = this.getTraitementRetour();
        const depotGestionValue = this.getDepot();

        return (
            <React.Fragment>
                <div className={classes.row}>
                    <FormControl required className={classes.formControl}>
                        <FormLabel>{traitementRetourLabel}</FormLabel>
                        <RadioGroup id={ReclamationQualificationDetailCodes.TraitementRetour} name={ReclamationQualificationDetailCodes.TraitementRetour} className={classes.group} value={detailTraitementRetourValue} onChange={this.handleQualificationDetailsTraitementRetourChange}>
                            {traitementsRetour.map((traitement, index) => (
                                <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={traitement} />
                            ))}
                        </RadioGroup>
                    </FormControl>
                </div>


                {detailTraitementRetourValue === '0' && (

                    <div className={classes.row}>
                        <Typography className={classes.row} variant="h6" gutterBottom>{`Magasin`}</Typography>
                        <DepotGestionSelect
                            className={classes.formControl}
                            value={depotGestionValue}
                            valueIsCode
                            onChange={this.handleQualificationDetailsCodeDepot}
                            magasinsSeulement
                            isRequired
                            autoFocus
                            label="Sélectionner un magasin :"
                            modeTri={1}
                            disabled={reclamation.magasin && reclamation.magasin.verrou}
                        />
                    </div>

                )}


            </React.Fragment>
        );
    }

    render() {
        const { classes, reclamation, namespace } = this.props;
        const { expandedPanel } = this.state;

        return (
            <React.Fragment>

                <div className={classes.row}>
                    <TextField
                        multiline
                        fullWidth
                        name="commentaire"
                        label="Commentaire"
                        placeholder="Décrire le problème rencontré"
                        maxRows="3"
                        onChange={this.handleChange}
                        value={reclamation.commentaire}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </div>

                <div className={classes.row}>
                    <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
                </div>

                <div className={classes.row}>
                    <Accordion expanded={expandedPanel === 'panelPiece'} onChange={this.handleChangePanel('panelPiece')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className={classes.panelSummary}
                        >
                            <Typography >Rechercher une pièce* (obligatoire pour accéder aux lignes)</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <PieceGestionSearch
                                onSelectPiece={this.handleSelectPiece}
                                client={reclamation.client}
                                withLignes
                                namespace={namespace}
                                warningReclamation
                                defautProduitInfos={false}
                                logistiqueInfos={false}
                                filterIMM30
                                defautNumeroPiece={reclamation.numeroPiece}
                            />

                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expandedPanel === 'panelLignes'} onChange={this.handleChangePanel('panelLignes')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className={classes.panelSummary}
                        >
                            <Typography >Sélectionner une ligne* (au moins une ligne en anomalie pour pouvoir créer la réclamation)</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className={classes.row}>
                                <LigneGestionQualification
                                    reclamation={reclamation}
                                    onAddLigne={this.handleAddLigne}
                                    onRemoveLigne={this.handleRemoveLigne}
                                    typeAnomalie={AnomalieType.ClientPasRetirerMarchandise}
                                />

                            </div>

                            <div className={classes.row}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={this.handleSelectAllLignes}
                                >
                                    Tout sélectionner
                                </Button>
                            </div>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion expanded={expandedPanel === 'panelLignes'}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className={classes.panelSummary}
                        >
                            <Typography >Qualification</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className={classes.flexContainer}>
                                {this.renderDetailsQualifications()}
                            </div>
                        </AccordionDetails>
                    </Accordion>

                </div>
            </React.Fragment>
        );
    }
}

ClientPasRetirerMarchandiseStep.propTypes = {
    reclamation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onDetailChange: PropTypes.func.isRequired,
    onSelectPiece: PropTypes.func.isRequired,
    onAddLigne: PropTypes.func.isRequired,
    onRemoveLigne: PropTypes.func.isRequired,
    onSelectAllLignes: PropTypes.func.isRequired,
    validationErrors: PropTypes.array,
    onNextStepValid: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired
};

export default withStyles(styles)(ClientPasRetirerMarchandiseStep);